// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Flex from '@/components/Flex'
import * as filters from './filters'

Vue.component('Flex', Flex)

Vue.config.productionTip = false
// 注册filter
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))

/* eslint-disable no-new */
const vRouter = new Vue({
  el: '#app',
  router,
  components: { App },
  data: {
    eventHub: new Vue() // global event bus
  },
  template: '<App/>'
})

Vue.use({
  vRouter
})
